import React from 'react';
import classNames from 'classnames';
import i18next from 'i18next';

import { CoreLink } from '@uncinc/react-drupal-core';
import { Button, Image } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const StaffTeaser = ({ entity, className }) => {
  const hasDetailPage = entity.getIn(['field_has_detail_page', 0, 'value'], false);
  const classes = classNames(className, 'StaffTeaser', { 'StaffTeaser--hasDetailPage': hasDetailPage });

  return (
    <article typeof="schema:WebPage" className={classes}>
      <CoreLink className="StaffTeaser__content" to={hasDetailPage && entity.getIn(['paths', 'nl'])}>
        <div className="StaffTeaser__imageWrapper">
          <Image
            alt={entity.getIn(['field_media', 0, 'title'], '')}
            lazyload={false}
            src={entity.getIn(['field_media', 0, 'styles', 'teaser_image'], '')}
            className="StaffTeaser__imageNormal"
          />
          <Image
            alt={entity.getIn(['field_media', 0, 'title'], '')}
            lazyload={false}
            src={entity.getIn(['field_media', 0, 'styles', 'teaser_square'], '')}
            className="StaffTeaser__imageMobile"
          />
        </div>
        <div className="StaffTeaser__contentWrapper">
          <div className='StaffTeaser__contentWrapper__name'>
            <h3>{entity.getIn(['title', 0, 'value'])}</h3>
            <span>{entity.getIn(['field_function', 0, 'value'])}</span>
          </div>
          <div className="social-links">
            {entity.getIn(['field_email', 0, 'value']) ? (
              <a
                onClick={(e) => e.stopPropagation()}
                href={`mailto:${entity.getIn(['field_email', 0, 'value'])}`} target="_blank" rel="noopener noreferrer" aria-label="Email"
              >
                <div className="icon-before icon-mail icon-variant-1" />
              </a>
            ) : null}
            {entity.getIn(['field_linkedin', 0, 'uri']) ? (
              <div
                onClick={(e) => e.stopPropagation()}
              >
                <CoreLink
                  to={entity.getIn(['field_linkedin', 0, 'uri'])}
                >
                  <div className="icon-before icon-linkedin icon-variant-1" />
                </CoreLink>
              </div>
            ) : null}
            {hasDetailPage && (
              <Button
                primary={false}
                className="Button--tertiary"
                href={entity.getIn(['paths', 'nl'])}
              >
                {i18next.t('more_about')}
              </Button>
            )}
          </div>
        </div>
      </CoreLink>
    </article >
  );
};

export default StaffTeaser;
